/* eslint-disable camelcase */
import React, { FC, useCallback, useMemo } from "react"
import { Appearance } from "react-native"
import { CompositeScreenProps } from "@react-navigation/native"
import { PondPreCreateMultipleForm as ModelForm, ModelCreateScreen } from "../../../../components"
import { observer } from "mobx-react-lite"
import { useStores } from "../../../../models"
import { navigate } from "../../../../navigators"

export const PondPreCreateMultipleScreen: FC<{ colorScheme?: "light" | "dark" } & CompositeScreenProps<any, any>> = observer(function PondPreCreateMultipleScreen(props) {
  const { colorScheme = "light" || Appearance.getColorScheme(), route: { params = {} } } = props

  // Pull in one of our MST stores
  const {
    appStore: { farmId },
    feedStore: modelStore
  } = useStores();

  const initialValues = useMemo<any>(() => {
    return {
      farm_id: farmId,
      total_ponds: 1,
      ...params,
    }
  }, [farmId, params])

  const onSubmit = useCallback((data: any) => {
    navigate('Home.Stack', 'Home.Pond.CreateMultiple', { ...data })
  }, [])

  return (
    <ModelCreateScreen
      colorScheme={colorScheme}
      ModelForm={ModelForm}
      initialValues={initialValues}
      modelStore={modelStore}
      onSubmit={onSubmit}
      ignoreDirty
      hideOnBlurred={false}
      saveTx="pondCreateMultipleScreen.title"
    />
  )
})
